import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const assignedContactsListSlice = createSlice({
    name: 'ui/assigned-contacts-list',
    initialState,
    reducers: listReducers
})

export const assignedContactsListActions = assignedContactsListSlice.actions
export default assignedContactsListSlice.reducer
